export const id = <T extends {}>(v: T): T => v

export const doNothing = (): void => {}

export const apply = <T, R = any>(x: T, f: (x: T) => R): R => f(x)

export const readonly = <T extends {}>(s: T): Readonly<T> => s
